import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CuentaBancariaForm from "components/abonos/CuentaBancariaForm";
import { errorAlert } from "helpers/alerts";
import { addCuenta } from "redux/slices/abonos/abonosSlice";
import { createCuentaService } from "services/abonos/abonosService";

const CreateCuentaScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = (data) => {
    createCuentaService(data)
      .then((response) => {
        dispatch(addCuenta(response));
        navigate(-1);
      })
      .catch((error) => errorAlert(error));
  };

  return (
    <CuentaBancariaForm
      title={"Administración de Cuentas"}
      goBack={() => navigate(-1)}
      submit={handleSubmit}
      defaultValues={{
        banco: "",
        numeroCuenta: "",
        clabe: "",
        beneficiario: "",
      }}
    />
  );
};

export default CreateCuentaScreen;
